"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InformNewsletterContent;
var _react = _interopRequireDefault(require("react"));
var _TextBox = _interopRequireDefault(require("../../../SIA-WEBSITE/TextBox/TextBox"));
var _List = _interopRequireDefault(require("../../../SIA-WEBSITE/List/List"));
var _Picture = _interopRequireDefault(require("../../../../components/Picture/Picture"));
var _DownloadLink = _interopRequireWildcard(require("../../../SIA-WEBSITE/DownloadLink/DownloadLink"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function InformNewsletterContent(_ref) {
  let {
    newsletter_content,
    lang,
    translate
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-05-top"
  }, newsletter_content.map((item, index) => {
    if (item.paragraph_type === 'text_box_col') {
      return /*#__PURE__*/_react.default.createElement(_TextBox.default, {
        key: index,
        items: item.text_box_elements,
        lang: lang
      });
    }
    if (item.paragraph_type === 'list') {
      return /*#__PURE__*/_react.default.createElement(_List.default, {
        key: index,
        title: item.title || '',
        items: item.paragraph_multi?.map(el => {
          return {
            content: el
          };
        }),
        variant: item.list_type.name.toUpperCase(),
        lang: lang
      });
    }
    if (item.paragraph_type === 'picture') {
      return /*#__PURE__*/_react.default.createElement(_Picture.default, {
        translate: translate,
        src: item.picture[0].original.url,
        copyright: item.picture[0].copyright,
        description: item.title
      });
    }
    if (item.paragraph_type === 'link_box') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sia-padding-05-bottom"
      }, /*#__PURE__*/_react.default.createElement(_DownloadLink.default, {
        variant: item.link.original_url.startsWith('http') ? _DownloadLink.variants.EXTERNAL : _DownloadLink.variants.INTERNAL,
        text: item.link.title,
        href: item.link.original_url,
        to: item.link.original_url
      }));
    }
  }));
}